import _ from "lodash";
import defaults from "./default";
const configEnv = process.env.NODE_ENV || "development";
var configOverride = require(`./${configEnv}`);
const configMerged = _.merge({}, defaults, configOverride.default);
export default configMerged;
